<div class="col-md-12 container">
  <div class="row mb-4">
    <div class="col-md-3"></div>
    <div class="col-md-6 pt-5 px-5">
      <img
        src="/assets/images/identibase/identibase-logo.jpg"
        class="img-fluid"
        alt="logo"
      />
    </div>
    <div class="col-md-3 pt-2">
      <button
        type="button"
        class="btn-close float-end"
        aria-label="Close"
        (click)="activeModal.dismiss()"
      >
      </button>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-md-12 header-container">
      <h4 class="search-modal-title">
        Join our pet-loving communities on Instagram for top tips, found pet stories and regular offers and giveaways
      </h4>
      <app-social-instagram class="instabadge"></app-social-instagram>
      <a href="https://www.instagram.com/identibase/"
        >&#64;identi • Instagram photos and videos</a
      >
    </div>
  </div>
</div>
